export default "__VITE_ASSET__CIKLbOnA__"